<template>
  <div class="big">
    <DocMsg
      :isFlag="doc_msg"
      :doctorId="doctorId"
    ></DocMsg>
    <div class="page_title">处方记录（已抓药）</div>
    <div style="padding:20px;border-radius:5px;">
      <div class="container">
        <div style="border-bottom:1px solid #e8e9f0">
        </div>
        <div
          style="padding: 0 24px 0 24px"
          class="big"
        >
          <div class="searchbox">
            <div class="item">
              <span>处方号</span>
              <el-input
                placeholder="请输入"
                v-model="pre_id"
                style="width: 120px; margin-left: 10px"
                @input="search"
                clearable
              ></el-input>
            </div>
            <div class="item">
              <span>处方类型</span>
              <el-select
                v-model="pre_group"
                placeholder="请选择"
                style="width: 120px; margin-left: 10px"
                clearable
                @change="search"
              >
                <el-option
                  v-for="(item, index) in pre_type_list"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div class="item">
              <span>患者姓名</span>
              <el-input
                placeholder="请输入"
                v-model="patient_name"
                style="width: 120px; margin-left: 10px"
                @input="search"
                clearable
              ></el-input>
            </div>
            <div class="item">
              <span>医生姓名</span>
              <el-input
                placeholder="请输入"
                v-model="doctor_name"
                style="width: 120px; margin-left: 10px"
                @input="search"
                clearable
              ></el-input>
            </div>
            <div class="item">
              <span>医生手机号</span>
              <el-input
                placeholder="请输入"
                v-model="doctor_phone"
                style="width: 120px; margin-left: 10px"
                clearable
                @input="search"
              ></el-input>
            </div>
            <div class="item">
              <span>所在省市</span>
              <el-select
                v-model="province_id"
                placeholder="请选择"
                @change="search"
                style="width: 140px; margin-left: 10px"
                clearable
              >
                <el-option
                  v-for="item in proList"
                  :key="item.province_id"
                  :label="item.name"
                  :value="item.province_id"
                ></el-option>
              </el-select>
            </div>
            <div class="item">
              <span>云诊所名称</span>
              <el-input
                placeholder="请输入"
                v-model="org_name"
                style="width: 140px; margin-left: 12px"
                clearable
                @input="search"
              ></el-input>
            </div>
            <div class="item">
              <span>开方时间</span>
              <el-date-picker
                v-model="date"
                type="daterange"
                range-separator="~"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                @change="search"
                clearable
                style="width: 225px; margin-left: 12px"
              ></el-date-picker>
            </div>
            <div class="item">
              <span>来源</span>
              <el-select
                v-model="pre_type"
                placeholder="请选择"
                style="width: 230px; margin-left: 10px"
                multiple
                clearable
                @change="search"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div class="item">
              <span>药房名称</span>
              <el-input
                placeholder="请输入"
                v-model="hospital_name"
                style="width: 120px; margin-left: 10px"
                @input="search"
                clearable
              ></el-input>
            </div>
            <div class="item">
              <span>药品剂型</span>
              <el-select
                v-model="drug_type"
                placeholder="请选择"
                style="width: 120px; margin-left: 10px"
                clearable
                @change="search"
              >
                <el-option
                  v-for="item in options2"
                  :key="item.drug_type"
                  :label="item.drug_type_name"
                  :value="item.drug_type"
                ></el-option>
              </el-select>
            </div>
            <div class="item">
              <span>是否隐藏剂量</span>
              <el-select
                v-model="is_show"
                placeholder="请选择"
                style="width: 120px; margin-left: 10px"
                clearable
                @change="search"
              >
                <el-option
                  v-for="item in options3"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>

            <div class="item">
              <span style="margin-right: 10px">是否已推送</span>
              <el-radio-group
                v-model="health_bool"
                @change="search"
              >
                <el-radio :label="0">全部</el-radio>
                <el-radio :label="1">是</el-radio>
                <el-radio :label="2">否</el-radio>
              </el-radio-group>
            </div>

            <div class="item">
              <el-button
                type="primary"
                size="small"
                @click="batchPush"
                :disabled="module_id_array[0] ? !module_id_array.includes('792') : false"
              >批量推送</el-button>
            </div>
          </div>
          <div style="border: solid 1px #c9cbd6">
            <el-table
              ref="multipleTable"
              :data="tableData"
              tooltip-effect="dark"
              style="width: 100%; min-width: 1000px"
              :header-cell-style="{ background: '#F5F5F5' }"
              @selection-change="handleSelectionChange"
            >
              <el-table-column type="selection"></el-table-column>
              <el-table-column
                label="开方时间"
                prop="create_time"
                width="90px"
              ></el-table-column>
              <el-table-column
                label="患者信息"
                width="90px"
              >
                <template slot-scope="scope">
                  <div>{{ scope.row.user_name }}</div>
                  <div>
                    <span v-if="scope.row.patient_sex == 1">男</span>
                    <span v-if="scope.row.patient_sex == 2">女</span>
                    <span style="margin-left: 10px">{{ scope.row.age }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="科室"
                prop="department_name"
              ></el-table-column>
              <el-table-column
                label="医生信息"
                width="110px"
              >
                <template slot-scope="scope">
                  <div
                    @click="showDocMsg(scope.row.doctor_id)"
                    style="cursor:pointer"
                  >{{ scope.row.doctor_name }}</div>
                  <div>
                    <span v-if="scope.row.doctor_sex == 1">男</span>
                    <span v-if="scope.row.doctor_sex == 2">女</span>
                    <span style="margin-left: 10px">{{ scope.row.title }}</span>
                  </div>
                  <div>{{ scope.row.phone }}</div>
                </template>
              </el-table-column>
              <el-table-column
                label="药房名称"
                prop="hospital_name"
              ></el-table-column>
              <el-table-column
                prop="province_name"
                label="所在省市"
              ></el-table-column>
              <el-table-column prop="pre_group">
                <template slot="header">
                  <div>处方类型/</div>
                  <div>药品剂型</div>
                </template>
                <template slot-scope="scope">
                  <div>{{ scope.row.drug_type_name }}</div>
                  <div v-if="scope.row.drug_machining">代煎</div>
                  <div v-if="scope.row.pre_num > 1">
                    ({{ scope.row.pre_sort }} / {{ scope.row.pre_num }})
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="药品金额"
                prop="drug_price"
              ></el-table-column>
              <el-table-column
                label="诊后管理费"
                prop="consult_drug_price"
              ></el-table-column>
              <el-table-column label="诊金">
                <template slot-scope="scope">
                  <span>{{
              scope.row.consulting_gold == '0.00'
                ? '免费'
                : scope.row.consulting_gold 
            }}</span>
                </template>
              </el-table-column>
              <!-- <el-table-column label="辅料费"
                               prop="excipients_price"></el-table-column>
              <el-table-column label="加工费"
                               prop="drug_machining_price"></el-table-column> -->
              <el-table-column
                label="是否隐藏剂量"
                width="80px"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.pre_group != 0||scope.row.pre_group  != -1">{{
              scope.row.is_show == 1 ? '否' : '是'
            }}</span>
                </template>
              </el-table-column>
              <el-table-column label="处方状态">
                <template slot-scope="scope">
                  <span>{{ scope.row.status | statusText }}</span>
                </template>
              </el-table-column>
              <el-table-column label="处方来源">
                <template slot-scope="scope">
                  <div>{{ scope.row.pre_type | preTypeText }}</div>
                  <span v-if="scope.row.org_name">{{ scope.row.org_name }}</span>
                </template>
              </el-table-column>

              <el-table-column
                label="是否已推送"
                width="80px"
              >
                <template slot-scope="scope">
                  <span>{{scope.row.health_id > 0 ? '是' : '否'}}</span>
                </template>
              </el-table-column>

              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    @click="toDetail(scope.row.pre_id)"
                    :disabled="module_id_array[0] ? !module_id_array.includes('795') : false"
                  >查看处方</el-button>
                  <el-button
                    type="text"
                    @click="onePush(scope.row)"
                    :disabled="module_id_array[0] ? !module_id_array.includes('792') : false"
                  >推送</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div style="margin-top: 24px">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="pagesize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalNum"
            ></el-pagination>
          </div>
          <!-- 生成二维码弹窗 -->
          <el-dialog
            title="对公转账二维码记录"
            :visible.sync="codebox"
            width="580px"
            :close-on-click-modal="false"
          >
            <div style="padding: 20px">
              <div
                class="flex_between"
                style="text-align: left; font-size: 15px"
              >
                <div>
                  <div>
                    <span style="display: inline-block; width: 100px">处方总金额</span>
                    <span>{{ codeInfo.total_price }}</span>
                  </div>
                  <div style="margin: 10px 0">
                    <span style="display: inline-block; width: 100px">处方数量</span>
                    <span>{{ codeInfo.total_num }}</span>
                  </div>
                  <div>
                    <span style="display: inline-block; width: 100px">转账备注</span>
                    <span>{{ codeInfo.remark }}</span>
                  </div>
                </div>
                <div>
                  <img
                    :src="codeInfo.qrcode"
                    alt
                    style="width: 130px; height: 130px"
                  />
                </div>
              </div>

              <div style="border: solid 1px #c9cbd6; margin-top: 10px">
                <el-table
                  ref="multipleTable"
                  :data="codeInfo.list"
                  tooltip-effect="dark"
                  style="width: 100%"
                  :header-cell-style="{ background: '#F5F5F5' }"
                >
                  <el-table-column
                    label="开方时间"
                    prop="create_time"
                    width="145"
                  ></el-table-column>
                  <el-table-column
                    label="患者姓名"
                    prop="user_name"
                  ></el-table-column>
                  <el-table-column
                    label="医生姓名"
                    prop="doctor_name"
                  ></el-table-column>
                  <el-table-column
                    label="处方号"
                    prop="pre_id"
                  ></el-table-column>
                  <el-table-column
                    label="处方金额"
                    prop="amount"
                  ></el-table-column>
                </el-table>
              </div>
            </div>
          </el-dialog>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import platform from '../../../api/platform';
import yewu from '../../../api/yewu';
import dayjs from 'dayjs';
import pushWeijianwei from '../../../api/pushWeijianwei';
import DocMsg from '../../../components/common/DocMsg.vue';
export default {
  data() {
    return {
      activeIndex: '0',
      date: [],
      totalNum: 0,
      patient_name: '',
      doctor_name: '',
      doctor_phone: '',
      currentPage: 1,
      pagesize: 10,
      drug_type: '',
      tableData: [],
      pre_type: [],
      org_name: '',
      is_show: '',
      province_id: '',
      proList: [],
      pre_group: '',
      pre_id: '',
      hospital_name: '',
      options: [
        {
          value: 1,
          label: '问诊开方'
        },
        {
          value: 2,
          label: '直接开方'
        },
        {
          value: 3,
          label: '重新开方'
        },
        {
          value: 4,
          label: '云诊所开方'
        },
        {
          value: 5,
          label: '手机号开方'
        },
        {
          value: 6,
          label: '微信开方'
        },
        {
          value: 7,
          label: '视频问诊开方'
        },
        {
          value: 8,
          label: '按方购药'
        },
        {
          value: 9,
          label: '拍方购药'
        },
        {
          value: 10,
          label: '开放平台开方'
        },
        {
          value: 11,
          label: '医生拍照开方'
        }
      ],
      options2: [],
      options3: [
        {
          value: '',
          label: '全部'
        },
        {
          value: 0,
          label: '是'
        },
        {
          value: 1,
          label: '否'
        }
      ],
      pre_type_list: [
        {
          label: '全部',
          value: ''
        },
        {
          label: '中药材',
          value: 1
        },
        {
          label: '养生方',
          value: 2
        },
        {
          label: '成药',
          value: 3
        }
      ],
      health_bool: 0,
      selection: [],
      codebox: false,
      codeInfo: {},
      doc_msg: false,
      doctorId: ''
    };
  },
  components: {
    DocMsg
  },
  filters: {
    preGroupText(val) {
      switch (val) {
        case 0:
          return '养生方';
        case -1:
          return '成药';
      }
    },
    statusText(val) {
      switch (val) {
        case 1:
          return '待取药';
        case 2:
          return '待审方';
        case 3:
          return '已通过';
        case 4:
          return '已抓药';
        default:
          return '已失效';
      }
    },
    preTypeText(val) {
      switch (val) {
        case 1:
          return '问诊开方';
        case 2:
          return '直接开方';
        case 3:
          return '重新开方';
        case 4:
          return '云诊所开方';
        case 5:
          return '手机号开方';
        case 6:
          return '微信开方';
        case 7:
          return '视频开方';
        case 8:
          return '按方购药';
        case 9:
          return '拍方购药';
        case 10:
          return '开放平台开方';
        case 11:
          return '医生拍照开方';
      }
    }
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  created() {
    this.getProvince();
    this.getDrugTypeList();
    this.getList();
  },
  methods: {
    //医生信息概要
    showDocMsg(doctor_id) {
      this.doctorId = doctor_id;
      this.doc_msg = !this.doc_msg;
    },
    //获取处方列表
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        prescription_status: 4,
        patient_name: this.patient_name,
        doctor_name: this.doctor_name,
        doctor_phone: this.doctor_phone,
        patient_id: 0,
        start_time: '',
        end_time: '',
        pre_type: this.pre_type.toString(),
        is_test: 2,
        drug_type: this.drug_type,
        org_name: this.org_name,
        is_show: this.is_show,
        province_id: this.province_id,
        pre_id: this.pre_id,
        pre_group: this.pre_group,
        hospital_name: this.hospital_name,
        health_bool: this.health_bool
      };
      if (this.date && this.date.length > 0) {
        data.start_time = dayjs(this.date[0]).format('YYYY-MM-DD');
        data.end_time = dayjs(this.date[1]).format('YYYY-MM-DD');
      }
      yewu.prescriptionList(data).then((res) => {
        if (res.code == 0) {
          this.tableData = res.data.list.map((item) => {
            item.create_time = platform.timestampToTime(item.create_time);
            return item;
          });
          this.totalNum = res.data.total;
        }
      });
    },
    //多选
    handleSelectionChange(val) {
      let data = val.filter((item) => {
        return item.health_id === 0;
      });
      this.selection = data.map((item) => {
        return item.pre_id;
      });
    },
    //获取省市列表
    getProvince() {
      this.axios
        .post('platform/platform/getProvinceCityDistrict')
        .then((res) => {
          this.proList = res.data.list;
        });
    },
    //获取平台开方可以选择的剂型列表
    getDrugTypeList() {
      let platform_type = 3;
      this.axios
        .post('platform/photograph/getDrugTypeList', { platform_type })
        .then((res) => {
          this.options2 = res.data.list;
        });
    },
    //查看详情
    toDetail(pre_id) {
      this.$router.push({
        path: '/home/yewu/chufangdetail',
        query: {
          pre_id
        }
      });
    },
    //发药
    toOrderDetail(order_id) {
      this.$router.push({
        path: '/home/order/orderdetail',
        query: {
          order_id
        }
      });
    },
    //搜索
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //每页数据
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //翻页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //生成二维码
    createCode() {
      if (!this.selection.length) {
        this.$message.error('请选择需要操作的处方');
        return false;
      }
      let pre_id = this.selection.toString();
      this.axios
        .post('platform/prescription/getPrescriptionAccountsQrcode', { pre_id })
        .then((res) => {
          if (res.code == 0) {
            if (res.data.status == 0) {
              this.$message.success('二维码生成成功！');
              let accounts_id = res.data.accounts_id;
              this.axios
                .post('platform/prescription/getPrescriptionAccountsInfo', {
                  accounts_id
                })
                .then((res) => {
                  if (res.code == 0) {
                    this.codeInfo = res.data;
                    this.codeInfo.list = this.codeInfo.list.map((item) => {
                      item.create_time = dayjs
                        .unix(item.create_time)
                        .format('YYYY-MM-DD HH:mm');
                      return item;
                    });
                    this.codebox = true;
                  }
                });
            } else {
              this.$message.error('该二维码记录已存在！');
            }
          }
        });
    },
    // 批量推送
    batchPush() {
      if (!this.selection.length) {
        this.$message.warning('请选择未推送的处方');
        return;
      }
      let params = {
        pre_id: this.selection.join(',')
      };
      this.onePush(params);
    },
    // 单条推送
    onePush(row) {
      if (row.health_id > 0) {
        this.$message.warning('请选择未推送的处方');
        return;
      }
      pushWeijianwei.uploadPrescription({ pre_id: row.pre_id }).then((res) => {
        let { code } = res;
        if (code === 0) {
          this.$message.success('推送成功');
          this.getList();
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 205px);
  padding-bottom: 20px;
}
.noneline {
  border: 0;
  padding: 0 20px;
}
.title {
  font-size: 16px;
  width: 90px;
}

.mydivider {
  margin: 0;
}

.btnbox {
  text-align: left;
  margin: 20px 0;
  padding-left: 14px;
}
.searchbox {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 20px;
  .item {
    margin-right: 30px;
    margin-top: 16px;
  }
}
</style>
